import { environment } from 'src/environments/environment'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { Observable } from 'rxjs'
import { filter, take } from 'rxjs/operators'
import { AccessRights } from 'src/app/features/role/user-role/user-role'

@Component({
  selector: 'configuration-option-filternaming-branding-card',
  templateUrl: './filternaming-branding-card.component.html',
  styleUrls: ['./filternaming-branding-card.component.scss']
})
export class ConfigurationOptionFilterNamingBrandingCardComponent
  implements OnInit
{
  public form: UntypedFormGroup
  @Input() isCollapsed: any = false
  //public isCollapsed = false
  public accessRights = AccessRights

  @Output() onSubmit = new EventEmitter<any>()
  @Input() formValues$: Observable<any>
  public availableLanguages = environment.frontendLanguages.reduce(
    (acc, curr) => {
      if (curr != 'xx') return (acc[curr] = true), acc
      else return acc
    },
    {}
  )

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      primaryfilterDisplayNameNl: [],
      primaryfilterDisplayNameEn: [],
      secondaryfilterDisplayNameNl: [],
      secondaryfilterDisplayNameEn: [],
      primaryfilterDisplayNameFr: [],
      primaryfilterDisplayNameDe: [],
      secondaryfilterDisplayNameFr: [],
      secondaryfilterDisplayNameDe: []
    })

    this.formValues$
      .pipe(
        filter(
          (formValues) =>
            formValues?.primary_filter_display_name &&
            formValues?.filter_display_name
        ),
        take(1)
      )
      .subscribe((formValues) => {
        if (formValues?.primary_filter_display_name) {
          const filterNameValues = JSON.parse(
            formValues.primary_filter_display_name
          )
          this.form.controls?.primaryfilterDisplayNameEn.setValue(
            filterNameValues.filter_display_name_en
          )
          this.form.controls?.primaryfilterDisplayNameNl.setValue(
            filterNameValues.filter_display_name_nl
          )
          this.form.controls?.primaryfilterDisplayNameFr.setValue(
            filterNameValues.filter_display_name_fr
          )
          this.form.controls?.primaryfilterDisplayNameDe.setValue(
            filterNameValues.filter_display_name_de
          )
        }

        if (formValues?.filter_display_name) {
          const filterNameValues = JSON.parse(formValues.filter_display_name)
          this.form.controls?.secondaryfilterDisplayNameEn.setValue(
            filterNameValues.filter_display_name_en
          )
          this.form.controls?.secondaryfilterDisplayNameNl.setValue(
            filterNameValues.filter_display_name_nl
          )
          this.form.controls?.secondaryfilterDisplayNameFr.setValue(
            filterNameValues.filter_display_name_fr
          )
          this.form.controls?.secondaryfilterDisplayNameDe.setValue(
            filterNameValues.filter_display_name_de
          )
        }
      })
  }

  public onFormSubmit() {
    if (!this.form.valid) {
      return
    }

    const {
      primaryfilterDisplayNameNl,
      primaryfilterDisplayNameEn,
      secondaryfilterDisplayNameNl,
      secondaryfilterDisplayNameEn,
      primaryfilterDisplayNameFr,
      primaryfilterDisplayNameDe,
      secondaryfilterDisplayNameFr,
      secondaryfilterDisplayNameDe
    } = this.form.controls

    this.onSubmit.emit({
      filter_display_name: JSON.stringify({
        filter_display_name_nl: secondaryfilterDisplayNameNl.value,
        filter_display_name_en: secondaryfilterDisplayNameEn.value,
        filter_display_name_fr: secondaryfilterDisplayNameFr.value,
        filter_display_name_de: secondaryfilterDisplayNameDe.value
      }),
      primary_filter_display_name: JSON.stringify({
        filter_display_name_nl: primaryfilterDisplayNameNl.value,
        filter_display_name_en: primaryfilterDisplayNameEn.value,
        filter_display_name_fr: primaryfilterDisplayNameFr.value,
        filter_display_name_de: primaryfilterDisplayNameDe.value
      })
    })
  }
}
